import API from "../../../helpers/devApi";

const API_ENDPOINTS = "/hrms_payroll_assign";

// Create  new Requisiton
export function getAllAttendance(payload) {
  return API.get(`/attendify/employee-attendance/filtered`, {
    params: {
      employee_ids: payload?.employee_ids,
      end_date: payload?.end_date,
      start_date: payload?.start_date,
    },
  });
}

export function getTenDaysAttendance(payload) {
  return API.post(`/attendify/getDayWiseAttendanceCount`, payload);
}

export function getAllLeaveSummery(payload) {
  return API.get(`/attendify/leave-policies/leaves/${payload?.employee_ids}`, {
    params: {
      year: payload?.year,
    },
  });
}

export function getHolidays(payload) {
  return API.get(`/attendify/company-holiday`, {
    params: {
      year: payload?.year,
      month: payload?.month,
    },
  });
}

export function getBirthdays() {
  return API.get(`/hrms_employee/birthdays/current-month`);
}

export function getHrCards() {
  return API.get(`/attendify/getHrCardsData`);
}

export function getTotalEmployee() {
  return API.get(`/hrms_employee/gender_wise/employee_count`);
}

export function getAllAssignTemplateList(page, size) {
  return API.get(`${API_ENDPOINTS}?page=${page}&size=${size}`);
}

export function getAssignTemplateDetails(id) {
  return API.get(`${API_ENDPOINTS}/${id}`);
}

export function updateAssignTemplate(id, payload) {
  return API.patch(`${API_ENDPOINTS}/${id}`, payload);
}

export function deleteAssignTemplate(id) {
  return API.delete(`${API_ENDPOINTS}/${id}`);
}

export function getAllEmployeeCard(payload) {
  return API.post(`/attendify/getEmployeeCard`, {
    end_date: payload?.end_date,
    start_date: payload?.start_date,
  });
}
